export default __webpack_public_path__ + "static/media/001-sweater.4e8a42c0.svg";